import request from 'src/network';
import { Document } from 'src/types/Document';
import { DocumentAnalysis } from '../components/pages/documentsV2/DocumentPageComponent';
import { DocumentV2Data, DocumentV2Response } from 'src/types/DocumentOrImageV2';

const apiPath = '/api/doc_analysis/list';
const apiPath2 = '/api/doc_analysis/docs';
const apiPath3 = '/api/doc_analysis/upsert';
const apiPath4 = '/api/doc_analysis/analyze';
const apiPath5 = '/api/doc_analysis/last_results';
const apiPath6 = '/api/doc_analysis/question';

export async function getAllDocumentsService() {
    const response = await request.GET<Document>(apiPath);
    response.items = response.items.map((t) => new Document(t));
    return response;
}

export async function getDocumentByIdService(id: string) {
    const response = await request.GET<Document>(`${apiPath2}/${id}`);
    response.item = new Document(response.item);
    return response;
}

export async function upsertDocumentService(document: any) {
    const doc = { ...document };

    delete doc.created_at;
    delete doc.updated_at;
    delete doc.user_id;
    delete doc.doc_id;
    delete doc.agent_id;



    const response = await request.POST<Document>(`${apiPath3}`, doc);
    response.item = new Document(response.item);
    return response;
}

export async function analyzeDocumentService(document: any) {
    const doc = { ...document };
    delete doc.created_at;
    delete doc.updated_at;
    delete doc.id;
    delete doc.source;
    delete doc.name;
    delete doc.result;
    delete doc.sbx_ai_agent; 
    delete doc.sbx_ai_doc_analysis;
    delete doc.config.vs_config.fetch_k;
    delete doc.config.vs_config.k;
    delete doc.config.vs_config.lambda_mult;
    delete doc.config.vs_config.score_threshold;
    delete doc.config.vs_config.search_type;
    const config = {...doc.config};
    doc.vs_config = config.vs_config;
    doc.doc_analysis_params = config.doc_analysis_params;
    delete doc.config;

    const response = await request.POST<Document>(`${apiPath4}`, doc);
    return response;
}

export async function analyzeDocumentServiceV2(document: DocumentAnalysis) {
    return await request.POST<Document>(`${apiPath4}`, document);
}

export async function resultsDocumentService(id: number) {
    const response = await request.GET<Document>(`/api/doc_analysis/docs/${id}/results`);

    if (response?.items){
        response.items = response.items.map(item => new Document(item));
    }

    if (response?.item){
        response.items = (response.item as any as any[]).map(item => new Document(item));
    }
    return response;
}

export async function getLastResultsDocumentsService() {
    const response = await request.GET<Document>(apiPath5);
    response.items = response.items.map(item => new Document(item));
    return response;
}

export async function askQuestionToDocumentService(document: DocumentV2Data) {
    return await request.POST<DocumentV2Response>(`${apiPath6}/es`, document);
}